import React from 'react'
import {
  View,
} from 'react-native'
import { createStackNavigator } from '@react-navigation/stack'

import { useContent } from '@sart/content'
import { theme, colors } from '@sart/styles'
import { CompanyIcon } from '@sart/icons'

import { stackNavigationProps } from '../nagivationProps'

import BuildYourPlan from './BuildYourPlan'

const Stack = createStackNavigator()

function BuildYourPlanStackNavigator() {

  const content = useContent()

  return(
    <Stack.Navigator
      initialRouteName='BuildYourPlan'
      screenOptions={{
        ...stackNavigationProps.screenOptions
      }}
    >
      <Stack.Screen
        name="BuildYourPlan"
        component={BuildYourPlan}
        options={{
          title: "Build Your Plan",
          headerShadowVisible: false,
          headerTitleStyle: theme.navigationHeader,
          headerLeft: () => (<View style={{paddingLeft: 15}}>
            <CompanyIcon color={colors.srGreen} height={60} width={60} />
          </View>)
        }}
        
      />
    </Stack.Navigator>
  )
}

export default BuildYourPlanStackNavigator